import {AfterViewInit, Component, ElementRef, EventEmitter, HostBinding, Input, NgZone, Output} from '@angular/core';
import {timer} from "rxjs";

import {Homonym} from '../../shared/models/homonym.model';
import {
  HOMONYM_BOX_MAX_PADDING_TOP, HOMONYM_BOX_MIN_PADDING_TOP,
  HOMONYM_BOX_PADDING,
  HOMONYM_BOX_TOLERANCE,
  HOMONYM_REPOSITION_DELAY, HOMOYNM_BOX_MIN_PADDING
} from "../../shared/defines/client.const";



@Component({
  selector: 'app-homonym-list-item',
  template: `
    <a class="item-box">
      <div class="item-list">
        <div class="item" *ngFor="let word of homonym.listWord">
          <app-homonym-disp [word]="word"></app-homonym-disp>
          <app-homonym-word-play-btn [word]="word"></app-homonym-word-play-btn>
        </div>
      </div>
      <div class="item-menu">
        <app-homonym-all-play-btn [homonym]="homonym"></app-homonym-all-play-btn>
      </div>
    </a>
  `,
})
export class HomonymListItemComponent implements AfterViewInit {
  @HostBinding('style.display') styleBlock = 'block';
  @Input() homonym: Homonym;
  @Output() afterViewInit = new EventEmitter<HomonymListItemComponent>();

  public get width(): number {
    return this.eRef.nativeElement.firstChild.offsetWidth;
  }

  public get height(): number {
    return this.eRef.nativeElement.firstChild.offsetHeight;
  }

  public isSingleColumn(): boolean {
    // console.warn('isSingleColumn()', this.width, window.innerWidth / 2 - HOMONYM_BOX_PADDING - HOMONYM_BOX_TOLERANCE);
    return this.width > window.innerWidth / 2 - HOMONYM_BOX_PADDING - HOMONYM_BOX_TOLERANCE
  }

  public getPaddingType1(): {left: number, top: number} {
    const width = window.innerWidth - HOMONYM_BOX_PADDING * 2 - HOMONYM_BOX_TOLERANCE;
    const maxPaddingLeft = width - this.width;
    const left = Math.floor(Math.random() * maxPaddingLeft) + HOMONYM_BOX_PADDING;

    const top = Math.floor(Math.random() * (HOMONYM_BOX_MAX_PADDING_TOP - HOMONYM_BOX_MIN_PADDING_TOP)) + HOMONYM_BOX_MIN_PADDING_TOP;

    // console.warn('getPaddingType1()', this.width, width, maxPaddingLeft, left, top);

    return {left, top};
  }

  public getPaddingTypeN(): {left: number, top: number} {
    const width = window.innerWidth / 2 - HOMONYM_BOX_PADDING - HOMONYM_BOX_TOLERANCE / 2;
    const maxPaddingLeft = width - this.width;
    const left = Math.floor(Math.random() * maxPaddingLeft) + HOMONYM_BOX_PADDING;

    const top = Math.floor(Math.random() * (HOMONYM_BOX_MAX_PADDING_TOP - HOMONYM_BOX_MIN_PADDING_TOP)) + HOMONYM_BOX_MIN_PADDING_TOP;

    // console.warn('getPaddingTypeN()', this.width, width, maxPaddingLeft, left, top);

    return {left, top};
  }

  constructor(
    public eRef: ElementRef,
    private zone: NgZone,
  ) {
  }

  ngAfterViewInit(): void {
    /**
     * 외부에 Event로 초기화를 알리면, 컴포넌트를 세로 2줄로 할 지 세로 1줄로 할지, 외부에서 CSS를 설정해서 변경한다.
     */

    this.afterViewInit.emit(this);

    // /**
    //  * 외부에서 구조가 바뀔 때까지 조금 더 기다린 후, 위치를 저장해야 한다.
    //  */
    // this.zone.runOutsideAngular(() => {
    //   timer(HOMONYM_REPOSITION_DELAY).subscribe(() => {
    //     this.homonym.offsetTop = this.eRef.nativeElement.offsetTop;
    //   });
    // });
  }

  // public SetOffsetTop(): void {
  //   this.zone.runOutsideAngular(() => {
  //     this.homonym.offsetTop = this.eRef.nativeElement.offsetTop;
  //   });
  // }
}
